import {useFileDownload} from '@domain/file-download'
import {useUpmPlantContext} from '@hconnect/upm'
import GetAppIcon from '@mui/icons-material/GetApp'
import {Box, Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../../consts'
import {useTrackPlannerEvent} from '../../../../helpers'
import {fetchDownloadElectricityDataExcel} from '../../../../hooks/api/electricity'

export const _ExcelDownload: React.FC = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  const trackPlannerEvent = useTrackPlannerEvent()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const downloadFile = useFileDownload()

  const downloadExcel = async () => {
    trackPlannerEvent({name: 'onExportProductionPlan'})
    const [file, headers] = await fetchDownloadElectricityDataExcel(plantCode)
    downloadFile(file, headers)
  }

  return (
    <Box sx={{display: 'flex', alignItems: 'center'}} onClick={() => void downloadExcel()}>
      <Button variant="text" sx={{color: 'primary.light'}}>
        <GetAppIcon sx={{mr: 0.5}} /> {t('planning.exportTable')}
      </Button>
    </Box>
  )
}

export const ExcelDownload = React.memo(_ExcelDownload)
